module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/dop&mina-c0d82ee769c45b279ca3c26a7a19ad5f.png";